<main id="loading-container" #bc_loading>
  <div class="content">

    <div class="loader"></div>
    <div class="text">{{showText}}</div>

  </div>
</main>